// extracted by mini-css-extract-plugin
export default {"container":"pR-z","title":"qR-z","link":"rR-z"};